var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error
    ? _c("div", { staticClass: "wp-10" }, [
        _c(
          "div",
          { staticClass: "placeholder" },
          [
            _c("p", { staticClass: "acenter" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Une erreur est survenue, veuillez réinitialiser la liste des filtres"
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: { label: _vm.$t.__("common.actions.reset") },
              on: {
                click: function($event) {
                  return _vm.$store.dispatch(_vm.listinghash + "/resetFilters")
                }
              }
            })
          ],
          1
        )
      ])
    : _c(
        "div",
        { staticClass: "steps-container" },
        _vm._l(_vm.funnel.steps, function(step) {
          return _c("pipeline-step", {
            key: step.id,
            attrs: {
              "step-data": step,
              listinghash: _vm.listinghash,
              opps: _vm.rows[step.id]
            },
            on: {
              "opportunity-update": _vm.updateStep,
              "opportunity-update-header": _vm.updateHeaderStep
            }
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }